import * as amplitude from "@amplitude/analytics-browser";

const TrackAmplitude = async () => {
  amplitude.init(process.env.REACT_APP_AMPLITUDE_KEY);
};

export default TrackAmplitude;
